import zViewButtonGroup from '../button/button-group.vue'

zViewButtonGroup.install = function(Vue){
    Vue.component(zViewButtonGroup.name, zViewButtonGroup)
}

export default zViewButtonGroup